exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".teams-spinner-inner .flex{display:flex;align-items:center}.teams-spinner-inner .flex.row{flex-direction:row}.teams-spinner-inner .text-indicator{margin:5px}\n", ""]);

